import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';

// Create HTTP link to your GraphQL endpoint
const httpLink = createHttpLink({
  uri: 'https://flow888.win/graphql', // Update with your backend GraphQL endpoint
});

// Create Apollo Client instance
const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
    },
    query: {
      errorPolicy: 'all',
    },
  },
});

export default client;
